import SfAceEditor from './sf-ace-editor'

onDomLoad(($dom) => {
  SfAceEditor.initialize($dom)
  window.Silverfin.SfAceEditor = SfAceEditor
})
